import React, { useContext, useState } from 'react'
import { PromiseSesionContext } from '../../Machines/SesionMachine';
import { PokemonCard } from '../../Models/PokemonCard';
import ModalMenuItem from '../ModalMenuItem/ModalMenuItem';
import AddCardForm from './AddCardForm';
import { MenuItem } from '../../Models/ModalItem';
import ListCardComponentPokemon from '../ListCardComponentPokemon/ListCardComponentPokemon';

const AddCardToInventary = () => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [card, setCard] = React.useState<PokemonCard>();

    const {error, sendError} = useContext(PromiseSesionContext);

    const [open, setOpen] = useState<boolean>(false);

    const addCardToInventary = () => {
        try
        {
        }
        catch(error)
        {
            setLoading(false);
            sendError({type: "ERROR", data:{message:"Error al cargar el inventario", type:"error"}})
        }
    }

    let menuItem:MenuItem =   {
        label: <span>Remover sensor</span>,
        title: "Agregar",
        key: '1',
        icon: <></>,
        component: <AddCardForm card={card} />,
        type: 'CONTENT',
        items: [],
        size: 'small',
        onConfirm: () => {},
    
      }

    const selectCard = (card:PokemonCard) => {
        
        setCard(card);
        setOpen(true);
    }

  return (
    <div>
        
        <ListCardComponentPokemon type='all' subType='Private' hasPrice onClick={selectCard} ></ListCardComponentPokemon>

        
        <ModalMenuItem size='normal' menuItem={menuItem} open={open} setOpen={setOpen} updateSize />
        
    </div>
  )
}

export default AddCardToInventary